import React__default from 'react';
import styled from 'styled-components';
import { BreakpointWidths } from '../../../breakpoints/config.esm.js';
import { toBreakpointStyles } from '../../../breakpoints/utils.esm.js';
import { spacing } from '../../../tokens/spacing/spacing.esm.js';
import { primaryColumnWidth, secondaryColumnWidth, defaults } from './config.esm.js';

var getPrimaryBasis = function getPrimaryBasis(template) {
  return primaryColumnWidth[template];
};

var getSecondaryBasis = function getSecondaryBasis(template) {
  return secondaryColumnWidth[template];
};
/**
 * A simple two column layout displayed via flex box can only take two children
 * and will display them in the order they are passed in.
 *
 * - default template is `fiftyfifty`
 *
 * [View in Storybook](https://ds.test.onepeloton.com/?path=/story/story/layout-twocolumnlayout)
 */


var TwoColumnLayout = React__default.forwardRef(function TwoColumnLayout(_ref, ref) {
  var firstChildWidthPercent = _ref.firstChildWidthPercent,
      minHeight = _ref.minHeight,
      variant = _ref.variant,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? defaults.template : _ref$template,
      children = _ref.children,
      reverse = _ref.reverse,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      is = _ref.is,
      id = _ref.id,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? spacing[24] : _ref$gap;
  return React__default.createElement(Section, {
    as: is,
    backgroundColor: backgroundColor,
    className: className,
    id: id,
    ref: ref
  }, React__default.createElement(StyledTwoColumnLayout, {
    reverse: reverse,
    template: template,
    minHeight: minHeight,
    variant: variant,
    firstChildWidthPercent: firstChildWidthPercent,
    gap: gap
  }, children));
});
var Section = /*#__PURE__*/styled.section.withConfig({
  displayName: "TwoColumnLayout__Section",
  componentId: "design-system__sc-1qi7m2o-0"
})(["", ";"], function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor && "background-color: ".concat(backgroundColor);
});
/**
 * This component should eventually be deprecated in favor of @page-builder
 * When transferred to @page-builder, replace the variables below with the variables in:
 * packages/@page-builder/modules/tokens.ts
 */

var desktopInlinePadding = 40;
var containerMaxWidth = 1224;
var StyledTwoColumnLayout = /*#__PURE__*/styled.div.withConfig({
  displayName: "TwoColumnLayout__StyledTwoColumnLayout",
  componentId: "design-system__sc-1qi7m2o-1"
})(["display:flex;flex-direction:column;@media (min-width:", "px){", ";flex-direction:", ";", ";justify-content:space-around;", ";& > *:first-child{flex:", ";}& > *:last-child{flex:", ";}}"], BreakpointWidths.desktop, function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'contained' && "\n    padding: ".concat(spacing[120], " ").concat(desktopInlinePadding, "px;\n    margin: 0 auto;\n    max-width: ").concat(containerMaxWidth, "px;\n    box-sizing: content-box;\n  ");
}, function (_ref4) {
  var reverse = _ref4.reverse;
  return reverse ? 'row-reverse' : 'row';
}, function (_ref5) {
  var gap = _ref5.gap;
  return gap && toBreakpointStyles(gap, "gap");
}, function (_ref6) {
  var minHeight = _ref6.minHeight;
  return minHeight && "min-height: ".concat(minHeight);
}, function (_ref7) {
  var template = _ref7.template,
      firstChildWidthPercent = _ref7.firstChildWidthPercent;
  return firstChildWidthPercent ? firstChildWidthPercent : getPrimaryBasis(template);
}, function (_ref8) {
  var template = _ref8.template,
      firstChildWidthPercent = _ref8.firstChildWidthPercent;
  return firstChildWidthPercent ? "".concat(100 - parseInt(firstChildWidthPercent, 10), "%") : getSecondaryBasis(template);
});

export { TwoColumnLayout as default };
//# sourceMappingURL=TwoColumnLayout.esm.js.map
